import React, { Fragment, useEffect, useState } from "react";
import Breadcrumb from "../../../../layout/breadcrumb";
import { Card, CardBody, Row, Col, Container, Table, Button, Popover, PopoverBody, PopoverHeader } from "reactstrap";

import { useDispatch, useSelector } from "react-redux";
import { IoIosImages } from "react-icons/io";
import withReducer from "../../../../store/withReducer";
import {
    getOrderSettings,
    setSettings,
    viewPendingReturnRequestList,
    resendTrackingEmail,
    regenerateTracking,
    syncReturnTracking,
    openRefundReturnFeeDialog,
    closeRefundReturnFeeDialog,
    refundReturnFee,
    downloadAuthenticatedFile,
    retryDraftOrder,
    resendInvoiceReturnFeeReturnRequest,
} from "../../store/orderSlice";
import { useHistory, useParams } from "react-router-dom";
import orderReducer from "../../store";
import * as yup from "yup";
import {useForm} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup";
import "react-datepicker/dist/react-datepicker.css";
import PreLoader from "../../../../share-components/ui/preLoader";
import ReturnProcessTimeline from "./content/ReturnProcessTimeline";
import TrackingLogsModal from "./content/TrackingLogsModal";

import { toast } from "react-toastify";
import "../styles.scss";
import ModalFormSubmit from "../../../../share-components/form/modalFormSubmit";
import RefundReturnReasonForm from "./content/refundReturnReasonForm";
import ReactImageVideoLightbox from "react-image-video-lightbox";
import { getFileExtension } from "../../../../utils/common";

const defaultValues = {
    id: '',
    reason: '',
};

const schema = yup.object().shape({
    reason: yup.string().required('You must enter a reason'),
    // tageName: yup.string().required('You must enter a tag name'),
});

const ViewPendingReturn = (props) => {
    const { id } = useParams();
    const dispatch = useDispatch();
    let history = useHistory();
    const orderState = useSelector(({ order }) => order.order);
    const [loading, isSetLoading] = useState(true);
    const [resendButtonDisabled, setResendButtonDisabled] = useState(false);
    const [regenerateButtonDisabled, setRegenerateButtonDisabled] = useState(false);
    const [syncTrackingButtonDisabled, setSyncTrackingButtonDisabled] = useState(false);
   
    const authData = useSelector(({ authReducer }) => authReducer);
    const userState =  authData.data;
    const isSellerUser = userState.user.role.name === "Seller";
    const [buttonDisable, setButtonDisable] = useState(false);
    const [trackingLogsModalOpen, setTrackingLogsModalOpen] = useState(false);
    const initilindex = { index: 0, isOpen: false };
    const [photoIndex, setPhotoIndex] = useState(initilindex);
    const [viewFile, setViewFile] = useState([]);
    const [isEveryItemsCancelled, setIsEveryItemsCancelled]= useState(false)
    const [labelDownloading, setLabelDownloading] = useState(null);
    const [qrDownloading, setQrDownloading] = useState(null);
    const [retryLoading, setRetryLoading] = useState(false);
    const [resendInvoiceLoading, setResendInvoiceLoading] = useState(false);
    const {handleSubmit, formState, reset, control, register, setValue, handleChange, trigger, getValues} = useForm({
        mode: 'onChange',
        defaultValues,
        resolver: yupResolver(schema)
    });
    
    const {errors} = formState;   

    const dataMenu = [
        {
            type: 1,
            text: 'Pending Return Requests',
            link: '/order/pending-return-requests'
        },
        {
            type: 0,
            text: "View"
        }
    ];

    useEffect(() => {
        dispatch(getOrderSettings()).then(res => {
            if (!res.error) {
                const results = {
                    settings: res.payload,
                    id: null
                }
                dispatch(setSettings(res.payload));
            }
        });
    }, [dispatch]);

    useEffect(() => {
        fetchView();
    }, [dispatch, authData.defaultSeller]);

    const fetchView = () => {        
        const requestParmas = {
            params: {
                seller: authData.defaultSeller?.value
            },
            id: id
        }
        dispatch(viewPendingReturnRequestList(requestParmas)).then(res => {
            if (!res.error) {
                isSetLoading(false);
                setSyncTrackingButtonDisabled(false);
                setRegenerateButtonDisabled(false);
            }
        });
    }

    useEffect(()=>{

        if(orderState && orderState.pendingReturnData && orderState.pendingReturnData.lists && orderState.pendingReturnData.lists.items){
           const isCancelled = orderState.pendingReturnData.lists.items.every(item => item.status = "Cancel")
           setIsEveryItemsCancelled(isCancelled)
        }

    },[orderState.pendingReturnData])

    const resendTrackingEmailClick = (tracking_id) => {
        setResendButtonDisabled(true);
        const payload = {
            tracking_id: tracking_id
        }
        dispatch(resendTrackingEmail({ ...payload })).then(res => {
            setResendButtonDisabled(false);
        });
    }

    const regenerateTrackingClick = (tracking_id) => {
        setRegenerateButtonDisabled(true);
        const payload = {
            tracking_id: tracking_id
        }
        dispatch(regenerateTracking({ ...payload })).then(res => {
            fetchView();
        });
    }

    const syncTrackingClick = (tracking_id) => {
        setSyncTrackingButtonDisabled(true);
        const payload = {
            tracking_id: tracking_id
        }
        dispatch(syncReturnTracking({ ...payload })).then(res => {
            fetchView();
        });
    }

    const handleRetryDraftOrder = () => {
        setRetryLoading(true);
        dispatch(retryDraftOrder(id)).then((res) => {
            setRetryLoading(false);
            if (res.error) {
                toast.error(res.payload?.message || "Retry failed. Please try again.", {
                    position: toast.POSITION.TOP_RIGHT,
                });
            } else {
                toast.success("Draft order created successfully.", {
                    position: toast.POSITION.TOP_RIGHT,
                });
                fetchView();
            }
        });
    };

    const handleResendInvoice = () => {
        setResendInvoiceLoading(true);
        dispatch(resendInvoiceReturnFeeReturnRequest({ id })).then((res) => {
            setResendInvoiceLoading(false);
            if (res.error) {
                toast.error("Failed to resend invoice. Please try again.", {
                    position: toast.POSITION.TOP_RIGHT,
                });
            }
        });
    };

    const handleFileDownload = (url, filename, setLoading, key) => {
        if (setLoading === setLabelDownloading && labelDownloading === key) return;
        if (setLoading === setQrDownloading && qrDownloading === key) return;
        setLoading(key);
        dispatch(downloadAuthenticatedFile(url)).then((res) => {
            if (res.error) {
                toast.error(res.payload?.error || "Failed to download file", {
                    position: toast.POSITION.TOP_RIGHT,
                });
            } else {
                const blob = new Blob([res.payload]);
                const blobUrl = window.URL.createObjectURL(blob);
                const link = document.createElement("a");
                link.href = blobUrl;
                link.setAttribute("download", filename);
                document.body.appendChild(link);
                link.click();
                link.remove();
                window.URL.revokeObjectURL(blobUrl);
            }
            setLoading(null);
        }).catch(() => {
            toast.error("Failed to download file", {
                position: toast.POSITION.TOP_RIGHT,
            });
            setLoading(null);
        });
    };

    const onSubmitForm = (dialog, data) => {

        const result = [];

        Object.values(dialog.orderLineItems).forEach((brandGroup) => {
            brandGroup.items.forEach((item) => {
                result.push({
                orderLineItemID: item.orderLineItemID,
                lineItemID: item.lineItemID
                });
            });
        });
       
        const refundReturndata ={
            return_request_id : dialog.id ?? null,
            user_id : data.user.id ?? null,
            reason : data.reason,
            customer_order : dialog.customerOrder,
            order_line_items : result
        }

        setButtonDisable(true)
        dispatch(refundReturnFee(refundReturndata)).then(res => {
            setButtonDisable(false)
            closeDialog();
            if(!res.error){
              console.log(res)
              history.push(`/order/pending-return-requests`); 
            }
        })
       
    };

    const closeDialog = () => {
        dispatch(closeRefundReturnFeeDialog());
    };

    const PopoverSyncTracking = (props) => {
        const {list} = props;
        const [popover, setPopover] = useState(false)
        const Toggle = () => setPopover(!popover);
        return (
            <>
                <Button color="primary" size="xs" type="button" className="" id={"SyncTrackingPopover-" + list.tracking.id} 
                    onClick={() => {
                        syncTrackingClick(list.tracking.id)
                    }} 
                    disabled={syncTrackingButtonDisabled || list.can_sync_tracking_status == 2}>
                        {syncTrackingButtonDisabled && <i className="fa fa-spinner fa-spin" />} Fetch Tracking Status
                </Button>
                {(list.can_sync_tracking_status == 2) && (
                    <Popover
                        placement="top"
                        isOpen={popover}
                        target={"SyncTrackingPopover-" + list.tracking.id}
                        toggle={Toggle}
                        trigger="hover"
                    >
                        <PopoverBody>
                            You have reached the usage limit for today. Please try again tomorrow.
                        </PopoverBody>
                    </Popover>
                )}
            </>
        );
    };

    const PopoverRegenerateTracking = (props) => {
        const {list} = props;
        const [popover, setPopover] = useState(false)
        const Toggle = () => setPopover(!popover);
        return (
            <>
                <Button 
                    color="primary" 
                    size="xs" 
                    type="button" 
                    className="pt-1 ml-1" 
                    onClick={() => {
                        regenerateTrackingClick(list.tracking.id)
                    }} 
                    disabled={regenerateButtonDisabled}>
                    {regenerateButtonDisabled && <i className="fa fa-spinner fa-spin" />} Regenerate
                </Button>

                {(list.tracking.error_message) && (
                    <>
                    <span id={"regenerateTrackingPopover-" + list.tracking.id} className="text-danger" style={{ cursor: "pointer", marginLeft: "12px" }}>
                        <i className="fa fa-info-circle" aria-hidden="true"></i>
                    </span>
                    <Popover
                        placement="top"
                        isOpen={popover}
                        target={"regenerateTrackingPopover-" + list.tracking.id}
                        toggle={Toggle}
                        trigger="hover"
                    >
                        <PopoverBody>
                            {list.tracking.error_message}
                        </PopoverBody>
                    </Popover>
                    </>
                )}
            </>
        );
    };


    function handleRefundReturnFee({id, authData, orderState}){
        dispatch(
            openRefundReturnFeeDialog({
                id,
                data: authData.data,
                customerOrder: orderState.pendingReturnData.customOrder,
                lists: orderState.pendingReturnData.lists,
            })
            );

           
    }


    return (
        <Fragment>
            {loading ? <>
                <PreLoader></PreLoader>
            </> : <>
                <Breadcrumb title={orderState.pendingReturnData.data ? "View Return Request for Order "+orderState.pendingReturnData.data.order_name : "View Return Request"} data={dataMenu} />
                <Container fluid={true}>
                    <Card>
                        <CardBody>
                            <Row>
                                <Col md="">
                                    <div className="mb-3">
                                        <span className="form-label font-weight-bold">Order ID : </span>
                                        <span>{orderState.pendingReturnData.data ? orderState.pendingReturnData.data.order_name : ""}</span>
                                    </div>

                                    <div>
                                        <span className="form-label font-weight-bold">Return Requested Date & Time: </span>
                                        <span>{orderState.pendingReturnData.data ? orderState.pendingReturnData.data.return_at : ""}</span>
                                    </div>
                                </Col>
                                {((orderState.pendingReturnData?.trackingLogs || []).length > 0) && (
                                <Col md="">
                                   {!orderState.pendingReturnData.onItemWithSubcription ?  
                                   <Button size="sm" className="float-right" onClick={() => setTrackingLogsModalOpen(true)}>
                                        <i className="fa fa-clock-o"/> Tracking Logs
                                    </Button> : ""}
                                </Col>
                                )}
                            </Row>
                        </CardBody>
                    </Card>

                    {orderState.pendingReturnData.data?.error_message && (
                        <Card>
                            <CardBody>
                                <div style={{ display: "flex", alignItems: "center", gap: "12px", background: "#fff2f0", border: "1px solid #ffccc7", borderRadius: "4px", padding: "12px 16px" }}>
                                    <i className="fa fa-exclamation-circle" style={{ color: "#cf1322", fontSize: "16px" }} />
                                    <span style={{ color: "#cf1322", flex: 1 }}>
                                        <strong>Draft Order Error: </strong>{orderState.pendingReturnData.data.error_message}
                                    </span>
                                    <Button color="danger" size="sm" disabled={retryLoading} onClick={handleRetryDraftOrder}>
                                        {retryLoading && <i className="fa fa-spinner fa-spin mr-1" />} Retry
                                    </Button>
                                </div>
                            </CardBody>
                        </Card>
                    )}

                    {orderState.pendingReturnData.lists &&
                        Object.keys(orderState.pendingReturnData.lists).map((key) => {
                            const list = orderState.pendingReturnData.lists[key];
                            const data = orderState.pendingReturnData?.data;
                            const fulfillmentStatus = (data?.fulfillment_status ?? data?.fulfillmentStatus ?? "").toString().toLowerCase();
                            const hideReturnLabelAndQr = fulfillmentStatus === "unfulfilled";
                            return (
                                <Card className="ribbon-wrapper" key={key}>
                                    <CardBody>
                                        <div className="ribbon ribbon-clip h6 ribbon-info">{list.brand_name}</div>
                                        {(!orderState.pendingReturnData.onItemWithSubcription && list.tracking) ? 
                                            <div className="table-responsive">
                                                <Table style={{width:'100%', border: "none"}}>
                                                    <tbody>
                                                        <tr>
                                                            <td style={{width:'50%', paddingLeft: 0}}>
                                                                <p><strong>Tracking Details:</strong></p>
                                                                <p>
                                                                    <strong>Carrier:</strong> {list.tracking.tracking_name}
                                                                </p>
                                                                <p>
                                                                    <strong>Tracking Number:</strong> {list.tracking.tracking_number ? list.tracking.tracking_number : '-'}
                                                                </p>
                                                                <p>
                                                                    <strong>Tracking URL:</strong> 
                                                                    {list.tracking.tracking_url ? (<a style={{textDecoration: 'underline', color: 'blue'}} target="_blank" href={list.tracking.tracking_url}>{list.tracking.tracking_url}</a>) : '-'}
                                                                </p>
                                                                {!hideReturnLabelAndQr && list.can_sync_tracking_status != 0 && (
                                                                    <p><PopoverSyncTracking list={list} /></p>
                                                                )}
                                                            </td>
                                                            <td>
                                                                {!hideReturnLabelAndQr && !isSellerUser && (
                                                                    <p><strong style={{width: '100px'}}>Return Label:</strong> <Button color="info" size="xs" className="pt-1" disabled={labelDownloading === key} onClick={() => handleFileDownload(list.tracking_label_url, `return-label-${key}.pdf`, setLabelDownloading, key)}>{labelDownloading === key && <i className="fa fa-spinner fa-spin mr-1" />}Download Return Label</Button></p>
                                                                )}

                                                                {!hideReturnLabelAndQr && !isSellerUser && list.tracking.tracking_id && <p><strong style={{width: '100px'}}>QR Code:</strong> <Button color="success" size="xs" className="pt-1" disabled={qrDownloading === key} onClick={() => handleFileDownload(list.tracking_qrcode_url, `qr-code-${key}.png`, setQrDownloading, key)}>{qrDownloading === key && <i className="fa fa-spinner fa-spin mr-1" />}Download QR Code</Button></p>}
                                                                
                                                                {!hideReturnLabelAndQr && list.can_resend_invoice && orderState.pendingReturnData.data.is_send_return_tracking_notification && (
                                                                <p><strong style={{width: '100px', marginTop: '15px'}}></strong> 
                                                                    <Button color="primary" size="xs" type="button" className="pt-1 ml-1" onClick={() => {
                                                                        resendTrackingEmailClick(list.tracking.id)
                                                                    }} disabled={resendButtonDisabled}>
                                                                        {resendButtonDisabled && <i className="fa fa-spinner fa-spin" />} Resend Tracking Details Email
                                                                    </Button>
                                                                </p>
                                                                )}

                                                                {list.can_regenerate && (
                                                                <p>
                                                                    <strong style={{width: '100px', marginTop: '15px'}}></strong> 
                                                                    <PopoverRegenerateTracking list={list} />
                                                                </p>
                                                                )}
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </Table>
                                            </div>
                                        : 
                                            <div className="table-responsive">Tracking details not found.</div>
                                        }

                                        
                                        {(!orderState.pendingReturnData.onItemWithSubcription && list.tracking_summary) && (
                                            <div className="mt-2 mb-5">
                                                <h6>Tracking Status:</h6>
                                                <ReturnProcessTimeline trackingSummary={list.tracking_summary}></ReturnProcessTimeline>
                                            </div>
                                        )}


                                        <div className="table-responsive mt-3">
                                            <Table style={{width:'100%'}}>
                                                <thead>
                                                    <tr className="table-primary">
                                                        <th  style={{ whiteSpace: 'nowrap',width:'30%' }}>Product</th>
                                                        <th style={{ whiteSpace: 'nowrap',width:'5%'  }}>Qty</th>
                                                        <th  style={{ whiteSpace: 'nowrap',width:'15%'  }}>Customer Reason</th>
                                                        <th  style={{ whiteSpace: 'nowrap' ,width:'10%' }} >Status</th>
                                                       {userState.user.role.name!=="Seller" && (
                                                        <>
                                                        <th  style={{ whiteSpace: 'nowrap' ,width:'10%' }} >Processed by</th>
                                                        <th  style={{ whiteSpace: 'nowrap' ,width:'10%' }} >Processed at</th>
                                                        <th  style={{ whiteSpace: 'nowrap' ,width:'5%' }} ></th>
                                                        </>
                                                       )}
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {list.items && list.items.map((item, i) => (
                                                        <tr key={item.id}>
                                                            <th>
                                                                <div className="row">
                                                                    <div className="col-md-2">
                                                                        <img className="img-fluid" src={item.image} width="40" alt=""/>
                                                                    </div>
                                                                    <div className="col-md-9">
                                                                        <div className="row">
                                                                            <p className={'font-primary'}>{item.productName}</p>
                                                                        </div>
                                                                        <div className="row">
                                                                            <p>{item.itemSku}</p>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </th>
                                                            <td>{item.returnRequestQuantity}</td>
                                                            <td><div className="mt-3">{item.reasonRequest}</div></td>
                                                            <td><div className="mt-3">{item.status}</div></td>
                                                            {userState.user.role.name!=="Seller" && (
                                                            <>
                                                            <td><div className="mt-3">{item.created_by || "-"}</div></td>
                                                            <td><div className="mt-3">{item.created_at || "-"}</div></td>
                                                            <td>
                                                                {item.images && item.images.length > 0 ? <button
                                                                    className="mt-3"
                                                                    style={{ backgroundColor: "transparent" }}
                                                                    onClick={() => {
                                                                        const imageList = (item.images || []).map((imgUrl) => ({
                                                                        url: imgUrl,
                                                                        type: imgUrl.endsWith(".mp4") ? "video" : "photo",
                                                                        altTag: "Return Item Image",
                                                                        }));
                                                                        setViewFile(imageList);
                                                                        setPhotoIndex({ index: 0, isOpen: true });
                                                                    }}
                                                                    >
                                                                    <IoIosImages size={22} />
                                                                    </button> : ""}
                                                            </td>
                                                            </>
                                                            )}
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </Table>
                                        </div>
                                    </CardBody>
                                </Card>
                            );
                        })
                    }


                    {(orderState.pendingReturnData.customOrder &&
                        orderState.pendingReturnData.customOrder.draft_order_invoice_url &&
                        orderState.pendingReturnData.customOrder.draft_order_status !== 'completed') && (
                        <Card className="ribbon-wrapper">
                            <CardBody>
                                <div className="ribbon ribbon-clip h6 ribbon-warning">Return Fee – Awaiting Payment</div>

                                <div className="mb-3">
                                    <span className="form-label font-weight-bold">Draft Order: </span>
                                    <span>{orderState.pendingReturnData.customOrder.draft_order_name}</span>
                                </div>

                                <div className="mb-3">
                                    <span className="form-label font-weight-bold">Amount: </span>
                                    <span>£{orderState.pendingReturnData.customOrder.amount}</span>
                                </div>

                                <div className="mb-3">
                                    <span className="form-label font-weight-bold">Status: </span>
                                    <span className="text-warning font-weight-bold">{orderState.pendingReturnData.customOrder.draft_order_status_name}</span>
                                </div>

                                <div className="mb-3">
                                    <span className="form-label font-weight-bold">Invoice Link: </span>
                                    <a
                                        href={orderState.pendingReturnData.customOrder.draft_order_invoice_url}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        style={{ textDecoration: "underline", color: "#1675e0", wordBreak: "break-all" }}
                                    >
                                        {orderState.pendingReturnData.customOrder.draft_order_invoice_url}
                                    </a>
                                </div>

                                <div className="mt-3">
                                    <Button color="primary" type="button" disabled={resendInvoiceLoading} onClick={handleResendInvoice}>
                                        {resendInvoiceLoading && <i className="fa fa-spinner fa-spin mr-1" />} Resend Invoice to Customer
                                    </Button>
                                </div>
                            </CardBody>
                        </Card>
                    )}

                    {(orderState.pendingReturnData.customOrder && orderState.pendingReturnData.customOrder.draft_order_status == 'completed') && <>
                        <Card className="ribbon-wrapper">
                            <CardBody>
                                <div className="ribbon ribbon-clip h6 ribbon-dark">Return Fee for Order Details</div>

                                <div className="mb-3">
                                    <span className="form-label font-weight-bold">Order ID : </span>
                                    <span>{orderState.pendingReturnData.customOrder.order_name}</span>
                                </div>

                                <div className="mb-3">
                                    <span className="form-label font-weight-bold">Amount : </span>
                                    <span>£{orderState.pendingReturnData.customOrder.amount}</span>
                                </div>

                                <div>
                                    <span className="form-label font-weight-bold">Financial Status : </span>
                                    <span>{orderState.pendingReturnData.customOrder.financial_status_name}</span>
                                </div>
                                {!isSellerUser && ((orderState.pendingReturnData.refundedBy && orderState.pendingReturnData.customOrder.financial_status_name === "Paid") ?
                                    <div style={{marginTop :"1rem"}}>
                                        <p style={{fontSize: "0.9rem",marginBottom:0 , color: "#1675e0"}}>Return fees refunded by <strong>{orderState.pendingReturnData.refundedBy.name}</strong> at this time <strong>{orderState.pendingReturnData.customOrder.refunded_at}</strong>.</p>
                                        <p className="form-label font-weight-bold">Reason : <span style={{ fontWeight: 400, fontSize: '0.9rem'}}>{orderState.pendingReturnData.customOrder.refunded_reason}</span></p>
                                    </div>
                                :
                                    <div style={{marginTop :"1rem"}}>
                                        <Button color="primary" type="button" onClick={()=>handleRefundReturnFee({id, authData, orderState})}>Refund the Return Fee</Button>
                                    </div>
                                )}
                            </CardBody>
                        </Card>
                    </>}

                </Container>
            </>}
            <ModalFormSubmit
                defaultValues={defaultValues}
                schema={schema}
                onSubmitForm={onSubmitForm}
                reset={reset}
                formState={formState}
                handleSubmit={handleSubmit}
                title='Refund Return Fee'
                selector='order'
                dialog={({order}) => order.order.refundReturnFeeModal}
                closeDialog={closeDialog}
                publish={false}
                loadingBtn={false}
                setValue={setValue}
                getValues={getValues}
                // btnText={btnText}
                // publishValue={publishValue}
                // saveValue={saveValue}
                buttonDisable={buttonDisable}
            >
                <RefundReturnReasonForm control={control} errors={errors} register={register} setValue={setValue} trigger={trigger} getValues={getValues}/>
            </ModalFormSubmit>

            {photoIndex.isOpen && (
                <div style={{ height: "100vh" }}>
                    <div className="lightbox-div">
                        <ReactImageVideoLightbox
                            title={"DAd"}
                            data={viewFile}
                            startIndex={photoIndex.index}
                            showResourceCount={true}
                            onCloseCallback={() => {
                            setPhotoIndex({ ...photoIndex, isOpen: false });
                            }}
                            onNavigationCallback={(currentIndex) => {
                            setPhotoIndex({ ...photoIndex, index: currentIndex });
                            }}
                        />
                    </div>
                </div>
            )}

            <TrackingLogsModal 
                isOpen={trackingLogsModalOpen}
                onClose={() => setTrackingLogsModalOpen(false)}
                trackingLogs={orderState.pendingReturnData?.trackingLogs || []}
            />
        </Fragment>
    );
}

export default withReducer([{ order: orderReducer }])(ViewPendingReturn);